<kzn-dialog [title]="title" [actionLabel]="actionLabel" [isActionDisabled]="isActionDisabled"
    [isActionInProgress]="isActionInProgress" (actionFired)="onAction()" [actionColor]="actionColor">
    <div [innerHTML]="message"></div>
</kzn-dialog>